import { render, staticRenderFns } from "./index_kr.vue?vue&type=template&id=971991b6&"
import script from "./index_kr.vue?vue&type=script&lang=js&"
export * from "./index_kr.vue?vue&type=script&lang=js&"
import style0 from "./index_kr.vue?vue&type=style&index=0&id=971991b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports